import { useEffect, useState } from "react";
import {
  DictionaryComponent,
  Theme,
  AppConfig,
  Dictionary,
} from "njamed-dictionary-maker";

const theme: Theme = {
  palette: {
    primary: "hsl(10, 55%, 15%)",
    secondary: "#A3553E",
    tertiary: "#f5f0ea",
    accent: "hsl(13, 47%, 93%)",
    accentText: "hsl(13, 10%, 50%)",
    paper: "hsl(30, 14%, 99%)",
    // green: "hsl(81, 50%, 55%)",
    green: "hsl(36, 100%, 40%)",
    brown: "#A3553E",
    text: "#222",
    lightText: "#777",
    background: "#212121",
    border: "#212121",
    error: "#f44336",
    success: "#4caf50",
    warning: "#ff9800",
    info: "#2196f3",
  },
  typography: {
    text1: `'Mulish', sans-serif`,
    text2: `'Meloso', serif`,
    displayFontFamily: "'Meloso', serif",
  },
};

const appConfig: AppConfig = {
  title: "Mayh dja Kundulk",
  subtitle: "Bininj Kunwok Plants & Animals",
  defaultCollection: "Types",
  audioCloudSrc:
    "https://res.cloudinary.com/dykmwkpgw/video/upload/bk-animals/",
  imgCloudSrc: "https://res.cloudinary.com/dykmwkpgw/image/upload/bk-animals/",
  appIcon: {
    src: "https://njamed.com/images/mimih.png",
    alt: "Dictionary icon",
    paddingVertical: 0,
  },
  sourceLanguage: {
    name: "English",
    shortName: "En",
  },
  targetLanguage: {
    name: "Dalabon",
    shortName: "Kb",
  },
  captchaPageText: {
    text: "# Welcome\n\nWelcome to this field guide of West Arnhem Land Animals and Plants (Mayh dja Kundulk). We pay our respect to all the Indigenous elders, educators and literacy workers past, present and emerging.\n\n## Indigenous Cultural and Intellectual Property\n\nThe languages in this field guide are the Indigenous Cultural Intellectual Property of Indigenous people who speak them (Bininj), and the right to use it is subject to traditional law and custom. This website is intended for use by individuals learning about plant-based vocabulary for the purpose of communication, and food collection under guidance of local people. Any other use of the language or information on this site, including teaching, research, or any commercial use requires the consent of the community.",
  },
  icons: {
    Dictionary: "book",
    Categories: "bookshelf",
    Reverses: "book",
    Info: "info",
    About: "info",
    Phrasebook: "speechBubble",
    Types: "bird",
  },
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN || "",
  settings: {
    collectionSettings: {
      collectionOrder: ["Types", "About"],
      collectionLabels: {
        Types: "Field Guide",
        Dictionary: "Word list (Kunwok)",
        Reverses: "Word list (English)",
      },
    },
  },
};

function App() {
  const [dictionary, setDictionary] = useState<Dictionary | null>(null);

  useEffect(() => {
    const dataPath = `${process.env.PUBLIC_URL}/data/normalized-entries.json`;
    fetch(dataPath)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("Got the data!");
        setDictionary(data);
      });
  }, []);

  return (
    <DictionaryComponent
      data={dictionary}
      theme={theme}
      appConfig={appConfig}
    />
  );
}

export default App;
